import useFormMethodsContext from '@src/shared/form/useFormMethodsContext';
import Switch from '@src/shared/ui/inputs/Switch';
import { type Control, Controller, type FieldValues } from 'react-hook-form';

type SwitchFieldProps = {
  name: string;
  disabled?: boolean;
};

function SwitchField({ name, disabled }: SwitchFieldProps) {
  const { control } = useFormMethodsContext() as { control: Control<FieldValues> };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Switch
          checked={Boolean(field.value)}
          disabled={disabled}
          onBlur={field.onBlur}
          onChange={(_, checked) => field.onChange(checked)}
          slotProps={{ input: { ref: field.ref } }}
        />
      )}
    />
  );
}

export default SwitchField;
